
import 'components/ckeditor.tag'
import 'components/loader.tag'
import 'pages/persons/persons-category-select-modal.tag'
import 'pages/persons/person-balance-modal.tag'
import 'pages/persons/persons-list-select-modal.tag'
import 'pages/settings/permissions/permission-user-list-modal.tag'
import 'pages/settings/add-fields/add-fields-edit-block.tag'
import md5 from 'blueimp-md5/js/md5.min.js'
import 'components/catalog.tag'
riot.tag2('person-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#persons" onclick="{backClick}"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;contacts&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reloadButton}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{[\'Редактирование контакта:\', ⁗[#⁗ + item.id + ⁗]⁗, item.lastName, item.firstName, item.secondName].join(⁗ ⁗)}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#person-edit-home">Информация</a></li>\n      <li if="{checkPermission(&quot;products&quot;, &quot;1000&quot;)}"><a data-toggle="tab" href="#person-edit-groups">Группы</a></li>\n      <li><a data-toggle="tab" href="#person-edit-referals">Приглашенные</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="person-edit-home">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="imageFile" section="contacts" alt="0" size="256" value="{item.imageFile}"></image-select>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-12">\n                  <div class="checkbox">\n                    <label>\n                      <input type="checkbox" name="isActive" __checked="{item.isActive == 1}">Активен\n                    </label>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-12">\n                  <div class="form-group"><span>Зарегистрирован:\n                      <nbsp></nbsp><b>{item.regDate}</b></span></div>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Фамилия</label>\n                    <input class="form-control" name="lastName" type="text" value="{item.lastName}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group {has-error: error.firstName}">\n                    <label class="control-label">Имя*</label>\n                    <input class="form-control" name="firstName" type="text" value="{item.firstName}">\n                    <div class="help-block">{error.firstName}</div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Отчество</label>\n                    <input class="form-control" name="secName" type="text" value="{item.secName}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group {has-error: error.email}">\n                    <label class="control-label">Email</label>\n                    <input class="form-control" name="email" type="text" value="{item.email}">\n                    <div class="help-block">{error.email}</div>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Логин</label>\n                    <input class="form-control" name="login" type="text" value="{item.login}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Пароль</label>\n                    <input class="form-control" name="password" type="password" value="{item.password}">\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-3">\n                  <div class="form-group">\n                    <label class="control-label">Персональная скидка</label>\n                    <div class="input-group">\n                      <input class="form-control" name="discount" min="0" step="0.01" value="{item.discount}" type="{\'number\'}"><span class="input-group-addon">%</span>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-3">\n                  <div class="form-group">\n                    <label class="control-label">Накопительная скидка</label>\n                    <input class="form-control" value="{item.progressiveDiscount + 0}%" disabled readonly>\n                  </div>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Примечание по контакту</label>\n                    <textarea class="form-control" rows="3" name="note" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div id="person-edit-orders" if="{checkPermission(&quot;orders&quot;, &quot;1000&quot;)}">\n            <div class="h4">Заказы пользователя</div>\n            <div class="row">\n              <div class="col-md-12">\n                <datatable cols="{cols}" rows="{orders}" handlers="{handlersOrders}" dblclick="{dblclickOrder}">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell class="{handlers.orderText.colors[row.status]}" name="status">{row.status}</datatable-cell>\n                  <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n                  <datatable-cell name="amount"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.curr !== null && row.curr !== ⁗⁗ ? row.curr : row.titleCurr}</span></datatable-cell>\n                  <datatable-cell name="note">{row.note}</datatable-cell>\n                </datatable>\n                <div class="pull-right"><strong> Суммма:</strong><strong> {currTotal.nameFront !== null && currTotal.nameFront !== ⁗⁗ ? currTotal.nameFront : ⁗⁗}</strong><strong> {(totalAmount || 0)}</strong><strong> {currTotal.nameFront !== null && currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : currTotal.nameFlang !== null && currTotal.nameFlang !== ⁗⁗ ? currTotal.nameFlang : currTotal.titleCurr}</strong></div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="person-edit-groups" if="{checkPermission(&quot;products&quot;, &quot;1000&quot;)}">\n          <catalog if="{item.id}" object="Contact" id="{item.id}" method="Info" items="groups" count="groupsCount" cols="{groupsCols}" allselect="true" store="person-edit" add="{permission(addGroup, &quot;persons-category-select-modal&quot;, &quot;0100&quot;)}" remove="{permission(removeGroups, &quot;persons-category-select-modal&quot;, &quot;0001&quot;)}" getdc="Contact" sortable="true" disablepagination="true">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog>\n        </div>\n        <div class="tab-pane fade" id="person-edit-referals">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-static name="referals" cols="{referalCols}" rows="{item.referals}">\n                <yield to="body">\n                  <datatable-cell name="id">{row.id}</datatable-cell>\n                  <datatable-cell name="username">{row.username}</datatable-cell>\n                  <datatable-cell name="refName">{row.refName}</datatable-cell>\n                  <datatable-cell name="email">{row.email}</datatable-cell>\n                  <datatable-cell name="phone">{row.phone}</datatable-cell>\n                  <datatable-cell name="refCount">{row.refCount}</datatable-cell>\n                  <datatable-cell name="regDate">{row.regDate}</datatable-cell>\n                </yield>\n              </catalog-static>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.item = {};
self.orders = [];
self.groupsSelectedCount = 0;
self.accountOperations = [];
self.referalFields = [];
self.allMode = false;

self.mixin('permissions');
self.mixin('validation');
self.mixin('change');

self.priceTypeTitle = [{ id: 0, name: 'Розничная' }, { id: 1, name: 'Мелкий опт' }, { id: 2, name: 'Оптовая' }];

self.backClick = function () {
    if (history.length > 2) history.back();else return true;
};

self.rules = {
    firstName: 'empty',
    email: {
        rules: [{
            type: 'email'
        }]
    } /*,
      phone: {
         rules:[{
             type: 'phone'
         }]
      }*/
};
//email: {rules: [{type: 'email'}]}

self.afterChange = function (e) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "afterChange" }));
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.cols = [{ name: 'id', value: 'Заказ' }, { name: 'status', value: 'Статус заказа' }, { name: 'dateOrder', value: 'Дата заказа' }, { name: 'amount', value: 'Сумма' }, { name: 'note', value: 'Примечание' }];

self.groupsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];

self.balanceCols = [{ name: 'datePayee', value: 'Дата' }, { name: 'inPayee', value: 'Приход' }, { name: 'outPayee', value: 'Расход' }, { name: 'balance', value: 'Баланс' }, { name: 'docum', value: 'Примечание' }];

self.referalCols = [{ name: 'id', value: '#' }, { name: 'username', value: 'Логин' }, { name: 'refName', value: 'Имя контакта' }, { name: 'email', value: 'E-mail' }, { name: 'phone', value: 'Телефон' }, { name: 'refCount', value: 'Пригл.' }, { name: 'regDate', value: 'Дата регистр.' }];

self.companyRequisitesHandlers = {
    valueChange: function valueChange(e) {
        var selectionStart = e.target.selectionStart;
        var selectionEnd = e.target.selectionEnd;
        this.row.value = e.target.value;

        this.update();
        e.target.selectionStart = selectionStart;
        e.target.selectionEnd = selectionEnd;
    }
};

self.addGroup = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addGroup" }));
    modals.create('persons-category-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            self.item.groups = self.item.groups || [];
            var items = this.tags.catalog.getSelectedMode();

            var ids = self.item.groups.map(function (item) {
                return item.id;
            });

            items.ids.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) {
                    self.item.groups.push({ id: item,
                        name: "0"
                    });
                }
            });

            if (self.datacatalog.ContactCategory && self.datacatalog.Contact) {
                // переносим id и name в таблицу групп
                var iddatacatalog = {}; // получаем id

                self.datacatalog.ContactCategory.forEach(function (item) {
                    // получаем id
                    iddatacatalog[item.id] = item;
                });

                items.ids.forEach(function (item) {
                    // по id составляем окончательный массив
                    var unit = {
                        id: item,
                        name: iddatacatalog[item]["name"]
                    };
                    self.datacatalog.Contact.push(unit);
                });

                var uniq = {};
                self.datacatalog.Contact.forEach(function (item) {
                    // фильтруем уникальные значения по id
                    uniq[item.id] = item;
                });
                self.datacatalog.Contact = []; // очистка исходного массива
                for (var item in uniq) {
                    // возвращаем уникальные значения
                    self.datacatalog.Contact.push(uniq[item]);
                }

                observable.trigger('datacatalog', self.datacatalog); // записываем в транс-табличные данные
            }

            self.update();
            self.tags.catalog.reload();
            this.modalHide();
        }
    });
};

self.recalcBalance = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "recalcBalance" }));
    var balance = 0.0;
    self.item.personalAccount.forEach(function (item) {
        balance += parseFloat(item.inPayee) - parseFloat(item.outPayee);
        item.balance = parseFloat(balance);
    });
};

self.addBalance = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addBalance" }));
    modals.create('person-balance-modal', {
        type: 'modal-primary',
        typeOperations: self.accountOperations,
        submit: function submit() {
            self.item.personalAccount.push(this.item);
            self.recalcBalance();
            self.update();
            this.modalHide();
        }
    });
};

self.editBalance = function (e) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "editBalance" }));
    modals.create('person-balance-modal', {
        type: 'modal-primary',
        typeOperations: self.accountOperations,
        item: e.item.row,
        submit: function submit() {
            self.recalcBalance();
            self.update();
            this.modalHide();
        }
    });
};

self.removeGroups = function (e, itemsToRemove, self) {

    /** удаление групп из временного списка
     *  (нужно, что бы все группы были на листе - нужны id для allDelete)
     *  @param {object} e MouseEvent - данные мыши
     *  @param {array or object}  itemsToRemove массив id's на удаление или объект с allMode and allModeLastParams
     *  @param {object} self данные по контакту
     *  @return {object} observable.trigger 'datacatalog'
     */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "removeGroups" }));

    self.groupsSelectedCount = 0;
    //self.item.groups = self.tags.groups.getUnselectedRows()

    /** если "удалить все" - получаем список id групп для последующего удаления */
    if (itemsToRemove.allMode != undefined) {
        itemsToRemove = [];
        self.items.forEach(function (item) {
            itemsToRemove.push(item.id);
        });
    }

    var iddatacatalog = {};
    self.datacatalog.Contact.forEach(function (item) {
        // получаем id
        iddatacatalog[item.id] = item;
    });
    self.datacatalog.Contact = []; // чистим

    itemsToRemove.forEach(function (item) {
        delete iddatacatalog[item]; // удаляем по id
    });

    for (var item in iddatacatalog) {
        // возвращаем
        self.datacatalog.Contact.push(iddatacatalog[item]);
    }
    observable.trigger('datacatalog', self.datacatalog); // записываем в транс-табличные данные

    self.update();
}; // удаление групп из временного списка

self.submit = function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit" }));

    self.item.groups = self.datacatalog.Contact; // загрузка изменений в группы перед сохранением
    var params = self.item;
    self.error = self.validation.validate(params, self.rules);

    if (!self.error) {
        if (self.item && self.item.password && self.item.password.trim() === '') delete self.item.password;else self.item.password = md5(self.item.password);

        API.request({
            object: 'Contact',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Контакт сохранен!', style: 'popup-success' });
                self.item = response;
                self.item.password = new Array(8).join(' ');
                self.update();
                observable.trigger('persons-reload');
            }
        });
    } else {
        popups.create({ title: 'Ошибка!', text: 'Имеются незаполненые поля !', style: 'popup-warning' });
    }
};

self.reloadButton = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reloadButton" }));
    modals.create('bs-alert', {
        type: 'modal-danger',
        title: 'Предупреждение',
        text: 'Будут потеряны не сохраненные данные. Вы точно хотите обновить эту страницу?',
        size: 'modal-sm',
        buttons: [{ action: 'yes', title: 'Обновить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
        callback: function callback(action) {
            if (action === 'yes') {
                self.reload();
            }
            this.modalHide();
        }
    });
}; // обновление страницы карточки контакта с всплывающим предупреждением

self.reload = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload" }));
    self.tags.catalog.reload(); // перезагрузка каталога
    observable.trigger('persons-edit', self.item.id);
};

observable.on('persons-edit', function (id) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "persons-edit" }));
    var params = { id: id };
    self.error = false;
    self.loader = true;
    API.request({
        object: 'Contact',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item = response;
            self.item.password = new Array(8).join(' ');
            self.accountOperations = response.accountOperations;
            self.loader = false;
            getOrders(self.item.id);
            getReferals(self.item.id);
            self.update();
            if (self.tags.catalog) self.tags.catalog.reload({ dcreset: true }); // перезагрузка каталога
        },
        error: function error(response) {
            self.item = {};
            self.loader = false;
            self.update();
            if (self.tags.catalog) self.tags.catalog.reload({ dcreset: true }); // перезагрузка каталога
        }
    });
});

function getReferals(idCustomer) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getReferals" }));
    var params = { id: idCustomer };
    //self.referalFields = []
    API.request({
        object: 'Referals',
        method: 'Fetch',
        data: params,
        success: function success(response, xhr) {
            if (!(response.items instanceof Array)) response.items = [];
            self.item.referals = response.items;
            self.update();
        }
    });
}

function getOrders(idCustomer) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getOrders" }));
    var params = { filters: { field: "idAuthor", value: idCustomer } };

    API.request({
        object: 'Order',
        method: 'Fetch',
        data: params,
        success: function success(response, xhr) {
            if (!(response.items instanceof Array)) response.items = [];
            self.orders = response.items;
            self.totalAmount = parseFloat(response.totalAmount);
            self.currTotal = response.currTotal;
            self.update();
        }
    });
}

self.changeManager = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeManager" }));
    modals.create('permission-user-list-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            self.item.managerName = '';
            var items = this.tags.catalog.tags.datatable.getSelectedRows();
            if (!items.length) return;

            self.item.managerId = items[0].id;
            if (items[0].lastName) self.item.managerName = items[0].lastName + ' ';
            if (items[0].firstName) self.item.managerName += items[0].firstName + ' ';
            if (items[0].secName) self.item.managerName += items[0].secName;

            self.update();
            this.modalHide();
        }
    });
};

self.removeManager = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "removeManager" }));
    self.item.managerId = null;
    self.item.managerName = null;
};

self.changeReferContact = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeReferContact" }));
    var id = self.item.id;
    modals.create('persons-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        id: id,
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();
            if (!items.length) return;

            self.item.idUp = items[0].id;
            self.item.referName = items[0].displayName;

            self.update();
            this.modalHide();
        }
    });
};

self.removeReferContact = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "removeReferContact" }));
    self.item.idUp = null;
    self.item.referName = null;
};

self.one('updated', function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "one" }));
    observable.trigger('datacatalog', {}); // очищаем транс-табличные данные
    self.tags.groups.on('row-selected', function (count) {
        self.groupsSelectedCount = count;
        self.update();
    });
});

self.orderText = {
    text: {
        Y: 'Оплачен', N: 'Не оплачен', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
    },
    colors: {
        Y: 'bg-success', N: 'bg-danger', K: 'bg-warning', P: null, W: null, C: null, T: null
    }
};

self.deliveryText = {
    text: {
        Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
    },
    colors: {
        Y: 'bg-success', N: 'bg-danger', M: null, P: null
    }
};

self.handlersOrders = {
    orderText: self.orderText,
    deliveryText: self.deliveryText
};

self.dblclickOrder = function (e) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "dblclickOrder" }));
    riot.route('/orders/' + e.item.row.id);
};

self.on('update', function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "update" }));
    localStorage.setItem('SE_section', 'contacts');
});

self.on('mount', function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
    riot.route.exec();
});

observable.on('datacatalog', function (e) {
    /** получение транс-табличных данных
     *  @param {object} e именаТаблиц-массивыСтрок
     *  @return {object} observable.trigger 'datacatalog'
     */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "datacatalog" }));
    self.datacatalog = e;
});

observable.on('tempdatacatalog', function (e) {
    /** получение транс-табличных временных данных
     *  и слияние массивов (данные таблицы + данные селектора)
     *  @param {object} e именаТаблиц-массивыСтрок
     *  @return {object} observable.trigger 'datacatalog'
     */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "tempdatacatalog" }));
    self.datacatalog = (0, _assign2.default)(self.datacatalog, e);
    observable.trigger('datacatalog', self.datacatalog);
});

self.debugParam = {
    module: "person-edit.tag",
    dClass: "person-edit",
    method: "",
    dComment: "",
    groupLog: "norm",
    dArray: undefined
};
self.debuger = function () {
    var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;

    /** ДЕБАГЕР
     * 1 Запуск логов
     * 2 Настройки
     * 3 Формирование строки
     * 4 Отступ
     * 5 Очередность и отображение
     *
     * self.debuger({ ...self.debugParam, method:"allParams" })
     *
     * self.debuger({ ...self.debugParam, method:"reload",
     *                groupLog: "reload", dComment:"response", dArray: response })
     */

    // 1
    var startList = {
        norm: true
    };

    if (startList[dp.groupLog] == true && document.domain == "localhost") {

        // 2
        var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
        var gr = true;var com = true;var met = true;var cl = true;var mod = true;

        // 3
        var groupLog = "gr: " + dp.groupLog;
        var comment = "com: " + dp.dComment;
        var method = "met: " + dp.method;
        var clas = "cl: " + dp.dClass;
        var module = "mod: " + dp.module;

        // 4
        var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
        var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
        var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
        var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
        var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;

        // 5
        var consoleLog = "|";
        if (gr == true) consoleLog += groupLog + groupLogLen;
        if (com == true) consoleLog += comment + commentLen;
        if (met == true) consoleLog += method + methodLen;
        if (cl == true) consoleLog += clas + clasLen;
        if (mod == true) consoleLog += module + modLen;

        console.warn(consoleLog);
        if (dp.dArray != undefined) console.log(dp.dArray);
    }
};
});


// WEBPACK FOOTER //
// ./pages/persons/person-edit.tag